import React from 'react';

const RequisitionContext = React.createContext({});

export const RequisitionProvider = RequisitionContext.Provider;
export const RequisitionConsumer = RequisitionContext.Consumer;
export default RequisitionContext;
